_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[23],{

/***/ "+eYM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShadowTitle; });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nKUr");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);




function Title(_ref) {
  var children = _ref.children,
      className = _ref.className;
  var titleClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()("text-white uppercase tracking-wide leading-normal font-bold", className);
  return /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["jsx"])("h1", {
    className: titleClass,
    children: children
  });
}

function ShadowTitle(_ref2) {
  var children = _ref2.children,
      className = _ref2.className;
  return /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["jsx"])(Title, {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("regular-shadow text-6xl", className),
    children: children
  });
} // function LargeShadowTitle({ children, className }) {
//   return (
//     <Title
//       className={classnames(
//         "texture-shadow text-3xl md:text-7xl lg:text-10xl",
//         className
//       )}
//     >
//       {children}
//     </Title>
//   );
// }
// export default function ShadowTitle({ children, className }) {
//   return (
//     <>
//       <SmallShadowTitle className={classnames("block md:hidden", className)}>
//         {children}
//       </SmallShadowTitle>
//       <LargeShadowTitle className={classnames("hidden md:block", className)}>
//         {children}
//       </LargeShadowTitle>
//     </>
//   );
// }

/***/ }),

/***/ "Dsvi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ Register; });

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("nKUr");

// EXTERNAL MODULE: ./components/ui/Layout.js
var Layout = __webpack_require__("njh5");

// EXTERNAL MODULE: ./components/ui/TextureTitle.js
var TextureTitle = __webpack_require__("sgi6");

// EXTERNAL MODULE: ./components/ui/ShadowTitle.js
var ShadowTitle = __webpack_require__("+eYM");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./components/tickets/TicketRegisterForm.js
var TicketRegisterForm = __webpack_require__("TV6C");

// CONCATENATED MODULE: ./components/tickets/TicketRegister.js






function RegisterForm() {
  var detailsClass = classnames_default()("mb-20");
  var titleClass = classnames_default()("flex flex-col items-center");
  var subTitleClass = classnames_default()("block md:flex font-bold text-2xl md:text-4xl mt-6 justify-center text-center");
  return /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
    className: "mx-auto max-w-screen-md px-4 my-16",
    children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
      className: detailsClass,
      children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
        className: "hidden md:block",
        children: /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
          className: titleClass,
          children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(TextureTitle["a" /* default */], {
            title: "React Day"
          }), /*#__PURE__*/Object(jsx_runtime["jsx"])(TextureTitle["a" /* default */], {
            title: "Bangalore"
          })]
        })
      }), /*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
        className: "block md:hidden",
        children: /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
          className: titleClass,
          children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(ShadowTitle["a" /* default */], {
            className: "mb-6",
            children: "React Day"
          }), /*#__PURE__*/Object(jsx_runtime["jsx"])(ShadowTitle["a" /* default */], {
            children: "Bangalore"
          })]
        })
      }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
        className: subTitleClass,
        children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("p", {
          children: "March 19-20, 2021"
        }), /*#__PURE__*/Object(jsx_runtime["jsx"])("p", {
          className: "mx-10 hidden md:block",
          children: "|"
        }), /*#__PURE__*/Object(jsx_runtime["jsx"])("p", {
          children: "Online"
        })]
      })]
    }), /*#__PURE__*/Object(jsx_runtime["jsx"])(TicketRegisterForm["a" /* default */], {})]
  });
}
// EXTERNAL MODULE: ./components/ui/PatternById.js + 1 modules
var PatternById = __webpack_require__("Xut4");

// EXTERNAL MODULE: ./components/ui/hooks.js + 6 modules
var hooks = __webpack_require__("fVUt");

// CONCATENATED MODULE: ./pages/register.js






function Register() {
  var _useWindowSize = Object(hooks["b" /* useWindowSize */])(),
      windowWidth = _useWindowSize.windowWidth;

  return /*#__PURE__*/Object(jsx_runtime["jsxs"])(Layout["a" /* default */], {
    children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(RegisterForm, {}), /*#__PURE__*/Object(jsx_runtime["jsx"])(PatternById["a" /* default */], {
      id: "footerShapes",
      width: windowWidth * 0.15,
      lgOnly: true,
      position: {
        bottom: 0,
        right: "5%"
      }
    })]
  });
}

/***/ }),

/***/ "c05+":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register",
      function () {
        return __webpack_require__("Dsvi");
      }
    ]);
  

/***/ }),

/***/ "fVUt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ useIsMobile; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ useWindowSize; });

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// CONCATENATED MODULE: ./components/ui/hooks.js


function useIsMobile() {
  var _React$useState = react_default.a.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isMobile = _React$useState2[0],
      setIsMobile = _React$useState2[1];

  Object(react["useEffect"])(function () {
    if (window && window.innerWidth < 640) {
      setIsMobile(true);
    }
  }, []);
  return isMobile;
}
function useWindowSize() {
  var _useState = Object(react["useState"])(undefined),
      windowWidth = _useState[0],
      setWindowWidth = _useState[1];

  var _useState2 = Object(react["useState"])(undefined),
      windowHeight = _useState2[0],
      setWindowHeight = _useState2[1];

  Object(react["useEffect"])(function () {
    function setWindowDimensions() {
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
    }

    window.addEventListener("resize", setWindowDimensions);
    setWindowDimensions();
    return function () {
      return window.removeEventListener("resize", setWindowDimensions);
    };
  }, []);
  return {
    windowWidth: windowWidth,
    windowHeight: windowHeight
  };
}

/***/ }),

/***/ "sgi6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextureTitle; });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nKUr");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);


function TextureTitle(_ref) {
  var title = _ref.title;
  return /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["jsx"])("div", {
    className: "flex items-start leading-tight md:leading-none text-7xl font-bold tracking-wide md:tracking-normal lg:text-8xl",
    children: /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["jsx"])("h1", {
      "data-text": title,
      className: "texture uppercase -ml-5",
      children: title
    })
  });
}

/***/ })

},[["c05+",0,1,2,3,4,5,9]]]);